import {useState} from 'react';

export default class AbstractFilter {

  public lista: any[];
  public setLista: any;
  public total: number;
  public setTotal: any;
  public page: number;
  public setPage: any;
  public pageSize: number;
  public setPageSize: any;


  constructor() {
    [this.lista, this.setLista] = useState([]);
    [this.total, this.setTotal] = useState(0);
    [this.page, this.setPage] = useState(0);
    [this.pageSize, this.setPageSize] = useState(0);
  }
}
